import './styles.scss';

// const dataValues = [30, 25, 40, 20, 15, 128]

export const RadarData = (dataChart) => {
  const labels = [];
  dataChart?.map(item => labels.push(item.title));
  const dataValues = [];
  dataChart?.map(item => dataValues.push(item.value));
  return {
    labels: labels,
    datasets: [
      {
        // label: "Family",
        pointLabelFontColor: "#000000",
        backgroundColor: "rgba(51, 199, 232, 0.86)",
        borderColor: "#1C9FBC",
        pointBackgroundColor: "#1C9FBC",
        poingBorderColor: "#fff",
        pointHoverBackgroundColor: "#1C9FBC",
        pointHoverBorderColor: "#1C9FBC",
        data: dataValues.map(item => item < 0 ? 0 : item > 200 ? 220 : item),
      }
    ]
  };
};

export const RadarOptions = (dataChart) => {
  const arrayValues = [];
  dataChart?.map(item => arrayValues.push(item.value));

  const dataValues = arrayValues.map(item => item < 0 ? 0 : item);
  const getValueMax = Math.max(...dataValues);

  let getMax;
  let stepSize;
  let gridColor;

  if (getValueMax > 0 && getValueMax <= 40) {
    getMax = 40;
    stepSize = 10;
    gridColor = "#ACB3BF";
  }
  if (40 < getValueMax && getValueMax <= 80) {
    getMax = 80;
    stepSize = 20;
    gridColor = "#ACB3BF";
  }
  if (getValueMax > 80 && getValueMax <= 120) {
    getMax = 120;
    stepSize = 30;
    gridColor = "#ACB3BF";
  }
  if (getValueMax > 120) {
    getMax = 200;
    stepSize = 50;
    gridColor = ["#ACB3BF", "#ACB3BF", "#ACB3BF", "#ACB3BF"];
  }

  return {
    animation: {
      duration: 0
    },
    scale: {
      min: 0,
      max: getMax,
      ticks: {
        pointLabelFontColor: "#000000",
        stepSize: stepSize,
        beginAtZero: true,
        showLabelBackdrop: false,
        backdropColor: "#ACB3BF"
      },
      gridLines: {
        color: 'black'
      },
      angleLines: {
        color: "ACB3BF",
        lineWidth: 1
      },
    },
    borderWidth: 1,
    elements: {
      point: {
        borderWidth: 1,
      }

    },
    scales: {
      r: {
        ticks: {
          font: {
            size: 10,
          },
          callback: function (value) {
            return (value / stepSize) % 2 === 0 ? this.getLabelForValue(value) + '%         ' : ''
          },
          backdropColor: 'transparent',
          color: "#3E4A5B",
          z: 999,
        },
        grid: {
          circular: true,
          color: gridColor,
          z: 9,
        },
        pointLabels: {
          callback: function (value, index) {
            switch (index) {
              case 0:
              case 1:
              case 5:
                return [value, ''];
              case 2:
              case 3:
              case 4:
                return ['', value];
              default:
                return value;
            }
          },
          color: "black",
          font: {
            size: 10,
            weight: 700,
            padding: 20
          },
          z: 9,
          tickWidth: 20
        }
      },
    },
    plugins: {
      beforeInit: function (chart) {
        chart.data.labels.forEach(function (label, index, labelsArr) {
          if (toString(" ").test(label)) {
            labelsArr[index] = label.split(toString(" "))
          }
        });
      },
      title: {
        display: false
      },
      legend: {
        display: false,
      },
      tooltip: {
        usePointStyle: true,
        callbacks: {
          labelPointStyle: function (context) {
            return {
              pointStyle: 'triangle',
              rotation: 0
            };
          },
          label: function (value) {
            return arrayValues[value.dataIndex]
          }
        }
      }
    },
    responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: 0,
      align: 'center',
    },
  };
};
